module.exports = __webpack_public_path__ + "static/img/guang.ca9c02b4.png";